import React from 'react';
import { PUAN_SECENEKLERI, puanSecimListesi, puanSecimOzeti } from '../../lib/zorlukSeviye';
import CokluSecici from './CokluSecici';

// Puan seviyesi ÇOKLU seçimi (2026-10-26, kullanıcı isteği "her seviye checkbox ile seçilebilsin,
// genel olarak kullanılsın"): CokluSecici + puan değer dili. Panel liste süzgeci (YKS ve LGS),
// müşteri paneli ve Basım (Soru ekle, Konu Testi / Genel Deneme puanı) aynı bileşeni kullanır.
// `deger`: değer dizisi ('yok', '2-4' …) ya da virgüllü dizgi; `onDegis(dizi)` seçenek sırasıyla döner. Boş = tümü.
const NITELIK = { kok: 'data-puan-secici', kutu: 'data-puan-secenek', tumu: 'data-puan-tumu' };

export default function PuanSecici({
  deger, onDegis, secenekler = PUAN_SECENEKLERI, etiket = 'Puan', ariaLabel = 'Puan filtresi',
  title = 'Puan seviyesi — birden çok seviye seçilebilir', dugmeSinifi = null,
}) {
  return (
    <CokluSecici deger={puanSecimListesi(deger)} onDegis={onDegis} secenekler={secenekler} etiket={etiket}
      ariaLabel={ariaLabel} title={title} dugmeSinifi={dugmeSinifi} nitelik={NITELIK}
      ozet={(secili) => puanSecimOzeti(secili.map((o) => o.value), secenekler)} />
  );
}
